/**
 * Countries Lookup Table
 *
 * Static mapping of country IDs to names and ISO codes.
 * Used for client-side resolution of country data from backend.
 *
 * Source: Backend database table 'countries'
 * Generated: 2026-02-12
 * Total: 197 countries
 *
 * Performance: O(1) lookup vs backend JOIN query
 */

export interface CountryLookupEntry {
  readonly name: string
  readonly iso: string
}

/**
 * Country lookup map (ID → {name, iso}).
 * Optimized for O(1) lookups.
 */
export const COUNTRIES_MAP: Record<number, CountryLookupEntry> = {
  55: { name: 'Afghanistan', iso: 'AF' },
  105: { name: 'Albania', iso: 'AL' },
  1: { name: 'Algeria', iso: 'DZ' },
  106: { name: 'Andorra', iso: 'AD' },
  2: { name: 'Angola', iso: 'AO' },
  149: { name: 'Antigua and Barbuda', iso: 'AG' },
  172: { name: 'Argentina', iso: 'AR' },
  56: { name: 'Armenia', iso: 'AM' },
  184: { name: 'Australia', iso: 'AU' },
  107: { name: 'Austria', iso: 'AT' },
  57: { name: 'Azerbaijan', iso: 'AZ' },
  150: { name: 'Bahamas', iso: 'BS' },
  58: { name: 'Bahrain', iso: 'BH' },
  59: { name: 'Bangladesh', iso: 'BD' },
  151: { name: 'Barbados', iso: 'BB' },
  108: { name: 'Belarus', iso: 'BY' },
  109: { name: 'Belgium', iso: 'BE' },
  152: { name: 'Belize', iso: 'BZ' },
  3: { name: 'Benin', iso: 'BJ' },
  60: { name: 'Bhutan', iso: 'BT' },
  173: { name: 'Bolivia', iso: 'BO' },
  110: { name: 'Bosnia and Herzegovina', iso: 'BA' },
  4: { name: 'Botswana', iso: 'BW' },
  174: { name: 'Brazil', iso: 'BR' },
  61: { name: 'Brunei', iso: 'BN' },
  111: { name: 'Bulgaria', iso: 'BG' },
  5: { name: 'Burkina Faso', iso: 'BF' },
  6: { name: 'Burundi', iso: 'BI' },
  7: { name: 'Cabo Verde', iso: 'CV' },
  62: { name: 'Cambodia', iso: 'KH' },
  8: { name: 'Cameroon', iso: 'CM' },
  153: { name: 'Canada', iso: 'CA' },
  9: { name: 'Central African Republic', iso: 'CF' },
  10: { name: 'Chad', iso: 'TD' },
  175: { name: 'Chile', iso: 'CL' },
  63: { name: 'China', iso: 'CN' },
  176: { name: 'Colombia', iso: 'CO' },
  11: { name: 'Comoros', iso: 'KM' },
  154: { name: 'Costa Rica', iso: 'CR' },
  112: { name: 'Croatia', iso: 'HR' },
  155: { name: 'Cuba', iso: 'CU' },
  64: { name: 'Cyprus', iso: 'CY' },
  113: { name: 'Czechia', iso: 'CZ' },
  12: { name: 'Democratic Republic of the Congo', iso: 'CD' },
  114: { name: 'Denmark', iso: 'DK' },
  15: { name: 'Djibouti', iso: 'DJ' },
  156: { name: 'Dominica', iso: 'DM' },
  157: { name: 'Dominican Republic', iso: 'DO' },
  177: { name: 'Ecuador', iso: 'EC' },
  16: { name: 'Egypt', iso: 'EG' },
  158: { name: 'El Salvador', iso: 'SV' },
  17: { name: 'Equatorial Guinea', iso: 'GQ' },
  18: { name: 'Eritrea', iso: 'ER' },
  115: { name: 'Estonia', iso: 'EE' },
  19: { name: 'Eswatini', iso: 'SZ' },
  20: { name: 'Ethiopia', iso: 'ET' },
  188: { name: '	 Federated States of Micronesia', iso: 'FM' },
  185: { name: 'Fiji', iso: 'FJ' },
  116: { name: 'Finland', iso: 'FI' },
  117: { name: 'France', iso: 'FR' },
  21: { name: 'Gabon', iso: 'GA' },
  22: { name: 'Gambia', iso: 'GM' },
  65: { name: 'Georgia', iso: 'GE' },
  118: { name: 'Germany', iso: 'DE' },
  23: { name: 'Ghana', iso: 'GH' },
  119: { name: 'Greece', iso: 'GR' },
  159: { name: 'Grenada', iso: 'GD' },
  160: { name: 'Guatemala', iso: 'GT' },
  24: { name: 'Guinea', iso: 'GN' },
  25: { name: 'Guinea-Bissau', iso: 'GW' },
  178: { name: 'Guyana', iso: 'GY' },
  161: { name: 'Haiti', iso: 'HT' },
  162: { name: 'Honduras', iso: 'HN' },
  120: { name: 'Hungary', iso: 'HU' },
  121: { name: 'Iceland', iso: 'IS' },
  66: { name: 'India', iso: 'IN' },
  67: { name: 'Indonesia', iso: 'ID' },
  68: { name: 'Iran', iso: 'IR' },
  69: { name: 'Iraq', iso: 'IQ' },
  122: { name: 'Ireland', iso: 'IE' },
  70: { name: 'Israel', iso: 'IL' },
  123: { name: 'Italy', iso: 'IT' },
  14: { name: 'Ivory Coast', iso: 'CI' },
  163: { name: 'Jamaica', iso: 'JM' },
  71: { name: 'Japan', iso: 'JP' },
  72: { name: 'Jordan', iso: 'JO' },
  73: { name: 'Kazakhstan', iso: 'KZ' },
  26: { name: 'Kenya', iso: 'KE' },
  186: { name: 'Kiribati', iso: 'KI' },
  124: { name: 'Kosovo', iso: 'XK' },
  74: { name: 'Kuwait', iso: 'KW' },
  75: { name: 'Kyrgyzstan', iso: 'KG' },
  76: { name: 'Laos', iso: 'LA' },
  125: { name: 'Latvia', iso: 'LV' },
  77: { name: 'Lebanon', iso: 'LB' },
  27: { name: 'Lesotho', iso: 'LS' },
  28: { name: 'Liberia', iso: 'LR' },
  29: { name: 'Libya', iso: 'LY' },
  126: { name: 'Liechtenstein', iso: 'LI' },
  127: { name: 'Lithuania', iso: 'LT' },
  128: { name: 'Luxembourg', iso: 'LU' },
  30: { name: 'Madagascar', iso: 'MG' },
  31: { name: 'Malawi', iso: 'MW' },
  78: { name: 'Malaysia', iso: 'MY' },
  79: { name: 'Maldives', iso: 'MV' },
  32: { name: 'Mali', iso: 'ML' },
  129: { name: 'Malta', iso: 'MT' },
  187: { name: 'Marshall Islands', iso: 'MH' },
  33: { name: 'Mauritania', iso: 'MR' },
  34: { name: 'Mauritius', iso: 'MU' },
  164: { name: 'Mexico', iso: 'MX' },
  130: { name: 'Moldova', iso: 'MD' },
  131: { name: 'Monaco', iso: 'MC' },
  80: { name: 'Mongolia', iso: 'MN' },
  132: { name: 'Montenegro', iso: 'ME' },
  35: { name: 'Morocco', iso: 'MA' },
  36: { name: 'Mozambique', iso: 'MZ' },
  81: { name: 'Myanmar', iso: 'MM' },
  37: { name: 'Namibia', iso: 'NA' },
  189: { name: 'Nauru', iso: 'NR' },
  82: { name: 'Nepal', iso: 'NP' },
  133: { name: 'Netherlands', iso: 'NL' },
  190: { name: 'New Zealand', iso: 'NZ' },
  165: { name: 'Nicaragua', iso: 'NI' },
  38: { name: 'Niger', iso: 'NE' },
  39: { name: 'Nigeria', iso: 'NG' },
  83: { name: 'North Korea', iso: 'KP' },
  134: { name: 'North Macedonia', iso: 'MK' },
  135: { name: 'Norway', iso: 'NO' },
  84: { name: 'Oman', iso: 'OM' },
  85: { name: 'Pakistan', iso: 'PK' },
  191: { name: 'Palau', iso: 'PW' },
  166: { name: 'Panama', iso: 'PA' },
  192: { name: 'Papua New Guinea', iso: 'PG' },
  179: { name: 'Paraguay', iso: 'PY' },
  180: { name: 'Peru', iso: 'PE' },
  87: { name: 'Philippines', iso: 'PH' },
  136: { name: 'Poland', iso: 'PL' },
  137: { name: 'Portugal', iso: 'PT' },
  88: { name: 'Qatar', iso: 'QA' },
  13: { name: 'Republic of the Congo', iso: 'CG' },
  138: { name: 'Romania', iso: 'RO' },
  89: { name: 'Russia', iso: 'RU' },
  40: { name: 'Rwanda', iso: 'RW' },
  167: { name: 'Saint Kitts and Nevis', iso: 'KN' },
  168: { name: 'Saint Lucia', iso: 'LC' },
  169: { name: 'Saint Vincent and the Grenadines', iso: 'VC' },
  193: { name: 'Samoa', iso: 'WS' },
  139: { name: 'San Marino', iso: 'SM' },
  41: { name: 'Sao Tome and Principe', iso: 'ST' },
  90: { name: 'Saudi Arabia', iso: 'SA' },
  42: { name: 'Senegal', iso: 'SN' },
  140: { name: 'Serbia', iso: 'RS' },
  43: { name: 'Seychelles', iso: 'SC' },
  44: { name: 'Sierra Leone', iso: 'SL' },
  91: { name: 'Singapore', iso: 'SG' },
  141: { name: 'Slovakia', iso: 'SK' },
  142: { name: 'Slovenia', iso: 'SI' },
  194: { name: 'Solomon Islands', iso: 'SB' },
  45: { name: 'Somalia', iso: 'SO' },
  46: { name: 'South Africa', iso: 'ZA' },
  92: { name: 'South Korea', iso: 'KR' },
  47: { name: 'South Sudan', iso: 'SS' },
  143: { name: 'Spain', iso: 'ES' },
  93: { name: 'Sri Lanka', iso: 'LK' },
  86: { name: 'State of Palestine', iso: 'PS' },
  48: { name: 'Sudan', iso: 'SD' },
  181: { name: 'Suriname', iso: 'SR' },
  144: { name: 'Sweden', iso: 'SE' },
  145: { name: 'Switzerland', iso: 'CH' },
  94: { name: 'Syria', iso: 'SY' },
  95: { name: 'Taiwan', iso: 'TW' },
  96: { name: 'Tajikistan', iso: 'TJ' },
  49: { name: 'Tanzania', iso: 'TZ' },
  97: { name: 'Thailand', iso: 'TH' },
  98: { name: 'Timor-Leste', iso: 'TL' },
  50: { name: 'Togo', iso: 'TG' },
  195: { name: 'Tonga', iso: 'TO' },
  170: { name: 'Trinidad and Tobago', iso: 'TT' },
  51: { name: 'Tunisia', iso: 'TN' },
  99: { name: 'Turkey', iso: 'TR' },
  100: { name: 'Turkmenistan', iso: 'TM' },
  196: { name: 'Tuvalu', iso: 'TV' },
  52: { name: 'Uganda', iso: 'UG' },
  146: { name: 'Ukraine', iso: 'UA' },
  101: { name: 'United Arab Emirates', iso: 'AE' },
  147: { name: 'United Kingdom', iso: 'GB' },
  171: { name: 'United States', iso: 'US' },
  182: { name: 'Uruguay', iso: 'UY' },
  102: { name: 'Uzbekistan', iso: 'UZ' },
  197: { name: 'Vanuatu', iso: 'VU' },
  148: { name: 'Vatican City', iso: 'VA' },
  183: { name: 'Venezuela', iso: 'VE' },
  103: { name: 'Vietnam', iso: 'VN' },
  104: { name: 'Yemen', iso: 'YE' },
  53: { name: 'Zambia', iso: 'ZM' },
  54: { name: 'Zimbabwe', iso: 'ZW' },
}

/**
 * Get country name by ID.
 * @param id - Country ID
 * @returns Country name or undefined if not found
 */
export function getCountryName(id: number): string | undefined {
  return COUNTRIES_MAP[id]?.name
}

/**
 * Get country ISO code by ID.
 * @param id - Country ID
 * @returns ISO code or undefined if not found
 */
export function getCountryISO(id: number): string | undefined {
  return COUNTRIES_MAP[id]?.iso
}

/**
 * Get full country entry by ID.
 * @param id - Country ID
 * @returns Country entry with name and ISO or undefined if not found
 */
export function getCountry(id: number): (CountryLookupEntry & { id: number }) | undefined {
  const entry = COUNTRIES_MAP[id]
  return entry ? { id, ...entry } : undefined
}
